<template>
    <div class="cc-selected-carrier" v-if="selectedCarrier">
        <div class="cc-selected-carrier__title">{{ translations['Selected carrier'] }}</div>
        <div class="cc-selected-carrier__information">{{ currentCarrier.name }}</div>
        <div class="cc-selected-carrier__price">{{ price }}</div>
        <div v-if="additionalShippingCosts > 0" class="cc-selected-carrier__information cc-selected-carrier__additional-shipping-costs">{{ translations['Includes additional shipping costs'] }}</div>
        <div v-if="additionalShippingCosts > 0" class="cc-selected-carrier__price cc-selected-carrier__additional-shipping-costs">{{ additionalShippingCostsFormatted }}</div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState({
                translations: state => state.translations,
                selectedCarrier: state => state.selectedCarrier,
                currentCarrier: state => state.currentCarrier,
                useVat: state => state.config.use_vat,
                additionalShippingCostsFormatted: state => state.additionalShippingCostsFormatted,
                additionalShippingCosts: state => state.additionalShippingCosts,
            }),
            price: function () {
              if (this.currentCarrier.free) {
                return this.translations['Free'];
              }
              if (this.useVat) {
                return this.currentCarrier.formattedPrices.price_without_additional_fee;
              }
              return this.currentCarrier.formattedPrices.price_without_tax_and_additional_fee;
            },
        },
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/components/selected-carrier";
</style>
